import { Box, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LwColorInput } from 'redesign';

export type SettingEditThemeFormData = {
  primaryColor?: string | null;
  secondaryColor?: string | null;
  primaryAccent?: string | null;
  secondaryAccent?: string | null;
};

export const SettingEditThemeForm = () => {
  const { control } = useFormContext<SettingEditThemeFormData>();
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="primaryColor"
            label={t('settings-theme-primary.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="secondaryColor"
            label={t('settings-theme-secondary.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="primaryAccent"
            label={t('settings-theme-primary_accent.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="secondaryAccent"
            label={t('settings-theme-secondary_accent.title')}
            control={control}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
